import React, { useState } from 'react';
import { buttonTypes } from './helpers';

function Buttons({ data, action, endGame }) {
    const [optionSelected, setOptionSelected] = useState(99);
    const [optionPreSelected, setOptionPreSelected] = useState(99);
    const [answerChosed, setAnswerChosed] = useState(false);
    const [showSliderConfirm, setShowSliderConfirm] = useState(false);

    const triggerAnswer = (index, answer, preAnswer) => {
        if (endGame) {
            action(answer);
            return;
        }
        if (preAnswer) {
            setOptionPreSelected(answer);
            setShowSliderConfirm(true);
            return;
        }
        if (!answerChosed) {
            setAnswerChosed(true);
            setOptionSelected(index);
            setTimeout(() => {
                action(answer);
                setOptionSelected(99);
                setAnswerChosed(false);
            }, 1000);
        }
    };

    return (
        <div className={`flex ${data.buttonsAlign === 'col' ? 'flex-col' : ''} items-center justify-center`}>
            {data?.buttons?.map(
                (button, index) => buttonTypes(
                    data.buttonsAlign,
                    button,
                    triggerAnswer,
                    index,
                    optionSelected,
                    showSliderConfirm,
                    optionPreSelected,
                ),
            )}
        </div>
    );
}

export default Buttons;
